import lPick from 'lodash/pick';
import isNil from 'lodash/isNil';
import negate from 'lodash/negate';
import isEmpty from 'lodash/isEmpty';

export function isOdd(num) {
	return num % 2;
}

export function safeJsonParse(obj) {
  if (obj && typeof obj === 'string') {
    try {
      return JSON.parse(obj);
    } catch (e) {
      // Do nothing here
    }
  }
  return null;
}

export function isObject(val) {
  return val !== null && typeof val === 'object';
}

export function isNonArrayObject(val) {
  return isObject(val) && !Array.isArray(val);
}

export const isNotEmpty = negate(isEmpty);

export const isNotNil = negate(isNil);

export function navigateOutApp(url = '') {
  return url && window.open(url, '_blank', 'noreferrer');
}

export function sleep(time) {
  return new Promise((resolve) => setTimeout(resolve, time));
}

export function isNilOrEmptyIterables(val) {
  return (
    isNil(val) ||
    (typeof val === 'string' && !val.length) ||
    (Array.isArray(val) && !val.length) ||
    (isNonArrayObject(val) && isEmpty(val))
  );
}

export function pick(obj, keys = [], regex) {
  const regexMatchedKeys = regex ? Object.keys(obj).filter(key => regex.test(key)) : [];
  const allKeys = [...new Set([...keys, ...regexMatchedKeys])];
  return lPick(obj, allKeys);
}

export function toBoolean(val) {
  if (isNil(val)) return false;
  if (typeof val === 'boolean') return val; 
  if (typeof val === 'number') {
      if (isNaN(val) || val === Infinity || val === -Infinity) return false;
      return val !== 0;
  }
  if (typeof val === 'string') {
      return !['false', '0', 'null', 'undefined', '', 'NaN'].includes(val.trim().toLowerCase());
  }
  return Boolean(val);
}
